import { closeAllItems } from 'src/all-items/all-items';
import { AbortedError } from 'src/common/api/extended-emerald-error';
import { addLineItemToTransaction } from 'src/home-page/business-logic/sale-mode-router';
import { ILineItemAddData } from 'src/items-list/business-logic/line-item-add';
import { restorePage } from '../../common/components/emerald-home-page/emerald-home-page';
import { showElectronicItemScreen } from '../components/electronic-item';

type ElectronicItemCallback = () => void;
let _electronicItemCallback: ElectronicItemCallback | undefined;

export const setElectronicItemCallback = (callback: ElectronicItemCallback): void => {
  _electronicItemCallback = callback;
};

export const resetElectronicItemCallback = (): void => {
  _electronicItemCallback = undefined;
};

export const handleElectronicItem = async (lineItem: ILineItemAddData): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    const onClose = (): void => {
      if (_electronicItemCallback) {
        _electronicItemCallback();
      }
      reject(new AbortedError());
    };

    const onSubmit = async (serialNumber: string): Promise<void> => {
      lineItem.lineItem.serialNumber = serialNumber;
      return addLineItemToTransaction(lineItem)
        .then(resolve)
        .catch(reject)
        .finally(() => {
          if (_electronicItemCallback) {
            _electronicItemCallback();
          }
        });
    };

    closeAllItems();

    showElectronicItemScreen({ onClose, onSubmit }, onSubmit);
  }).finally(() => restorePage());
};
